<template>
    <GuestLayout>
        <div class="mx-auto max-w-7xl px-6 sm:px-12 py-8 sm:py-12">
            <!-- Back to Blog -->
            <Link :href="route('blog.index')">
                <div class="flex items-center gap-2 mb-4">
                    <font-awesome-icon
                        icon="fa-solid fa-arrow-left"
                        class="text-gray-500 text-2xl"
                    />
                    <span class="text-gray-500 text-xl">Back to Blog</span>
                </div>
            </Link>
            <article class="prose prose-zinc dark:prose-invert max-w-max">
                <div class="md:flex md:space-x-6">
                    <div class="md:w-2/3">
                        <div class="space-y-2 not-prose">
                            <h1
                                class="text-4xl font-extrabold tracking-tight lg:text-5xl lg:leading-[3.5rem]"
                            >
                                {{ title }}
                            </h1>
                            <div class="flex gap-2">
                                <div class="flex gap-2">
                                    <Link
                                        v-for="{ title, href } in categories"
                                        :href="href"
                                        class="inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-foreground items-center"
                                    >
                                        {{ title }}
                                    </Link>
                                </div>
                                <p class="text-zinc-500 dark:text-zinc-400">
                                    / Posted on {{ published_at_formatted }}
                                </p>
                            </div>
                            <ShareButtons :url="href" />
                            <div v-if="tags?.length > 0" class="flex gap-2">
                                <span class="text-sm"> Tags: </span>
                                <Link
                                    v-for="{ title, href } in tags"
                                    :href="href"
                                    class="inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 items-center bg-bluewood-600 text-white"
                                >
                                    {{ title }}
                                </Link>
                            </div>
                        </div>
                        <figure>
                            <img
                                :alt="cover.alt"
                                class="aspect-video object-cover"
                                height="340"
                                :src="cover.default"
                                width="1250"
                            />
                        </figure>
                        <Toc class="block md:hidden" :html="toc" />
                        <div v-html="contentHtml"></div>
                    </div>
                    <aside class="md:w-1/3 sticky self-start top-0">
                        <Toc class="hidden md:block" :html="toc" />
                    </aside>
                </div>
            </article>
        </div>
        <RelatedPosts v-if="related.length > 0" :posts="related" />
        <SubscribeToNewsletter />
    </GuestLayout>
</template>

<script setup>
import GuestLayout from "@/Layouts/GuestLayout.vue";
import ShareButtons from "@/Components/Guest/Blog/ShareButtons.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { Link } from "@inertiajs/vue3";
import RelatedPosts from "@/Components/Guest/Blog/RelatedPosts.vue";
import SubscribeToNewsletter from "@/Components/Guest/Blog/SubscribeToNewsletter.vue";
import Toc from "@/Components/Guest/Blog/Toc.vue";

library.add(faArrowLeft);

const props = defineProps({
    post: {
        type: Object,
        required: true,
    },
    related: {
        type: Object,
        required: true,
    },
});

const {
    title,
    published_at_formatted,
    categories,
    tags,
    cover,
    contentHtml,
    href,
    toc,
} = props.post;
</script>
